let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bBeyC")).then(() => parcelRequire('dno9n'));